export function formatCurrency(currency) {
  return currency === "VES" ? "Bs. " : currency;
}
